// App.js (React Router v5 compatible)

import React, { useState, useEffect } from "react";
import { BrowserRouter as Router, Route, Switch, Redirect, Link } from "react-router-dom";
import { auth } from "./firebase";
import { signInWithEmailAndPassword, onAuthStateChanged, signOut } from "firebase/auth";
import GrindForm from "./components/GrindForm";
import GrindResults from "./pages/GrindResults";

function App() {
  const [user, setUser] = useState(null);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  useEffect(() => {
    onAuthStateChanged(auth, (u) => {
      setUser(u);
      if (u) console.log("Logged in as:", u.email);
    });
  }, []);

  const login = async () => {
    try {
      await signInWithEmailAndPassword(auth, email, password);
      alert("Logged in!");
    } catch (err) {
      alert(err.message);
    }
  };

  const handleLogout = () => {
    signOut(auth);
  };

  const HomePage = () => (
    user ? (
      <div className="min-h-screen bg-[#f3e3d0] flex flex-col items-center justify-start p-6 w-full">
        <div className="w-full flex justify-between items-center mb-4 px-4 max-w-4xl">
          <h3 className="text-lg text-[#3a241d] font-semibold">
            👋 Welcome back, Barista Master!
          </h3>
          <button
            onClick={handleLogout}
            className="bg-red-600 text-white px-4 py-2 rounded hover:bg-red-700 transition"
          >
            Log Out
          </button>
        </div>
        <GrindForm />
        <Link
          to="/grind-results"
          className="text-[#3a241d] underline hover:text-[#5c4432] block mt-4"
        >
          View Grind Results
        </Link>
      </div>
    ) : (
      <div className="min-h-screen bg-[#f3e3d0] flex flex-col items-center justify-center p-6">
        <div className="bg-white shadow p-6 rounded-xl space-y-4 max-w-sm w-full text-center mt-20">
          <h2 className="text-2xl font-bold">Sign In</h2>
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="border p-2 rounded w-full"
          />
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="border p-2 rounded w-full"
          />
          <button
            onClick={login}
            className="bg-[#3a241d] text-white py-2 px-4 rounded w-full"
          >
            Sign In
          </button>
        </div>
      </div>
    )
  );

  const ProtectedResults = () => (
    user ? <GrindResults /> : <Redirect to="/" />
  );

  return (
    <Router>
      <Switch>
        <Route exact path="/" render={HomePage} />
        <Route path="/grind-results" render={ProtectedResults} />
      </Switch>
    </Router>
  );
}

export default App;
